export interface TutorialStep {
  id: string;
  title: string;
  body: string;
}

interface Props {
  step: TutorialStep | null;
  onSkip: () => void;
  onNext?: () => void;
  showNext?: boolean;
}

export function TutorialOverlay({ step, onSkip, onNext, showNext }: Props) {
  if (!step) return null;
  return (
    <div className="tutorial-overlay" role="dialog" aria-labelledby="tutorial-title" aria-modal="true">
      <div className="tutorial-card">
        <p className="tutorial-eyebrow">Narrator (flustered)</p>
        <h2 id="tutorial-title">{step.title}</h2>
        <p className="tutorial-body">{step.body}</p>
        <div className="tutorial-actions">
          <button type="button" className="btn btn-ghost" onClick={onSkip}>
            Skip tutorial
          </button>
          {showNext && onNext && (
            <button type="button" className="btn btn-primary" onClick={onNext}>
              Got it
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
